import React, { useState, useEffect, memo } from 'react'


const CheckboxWrapper = ({ filtersId, item, updateList, updateSelection, apiField, defaultCondition }) => {

  const  [ checked, setChecked ] = useState(false)
  let label = item.name

  const onChange = () => {

    if ( filtersId === 'awards' ) {
      let filterName = item.name
      const filters = {
        filters: [
          {
            'field': 'awards.name',
            'condition': 'eq',
            'value': filterName,
          },
          {
            'field': 'awards.pivot.score',
            'condition': 'gte',
            'value': item.value,
          }
        ]
      }
      updateSelection(
        filters,
        !checked ? 'add' : 'remove'
      )
    } else {
      updateSelection(
        {
          'field': apiField,
          'condition': defaultCondition,
          'value': item.name,
        },
        !checked ? 'add' : 'remove'
      )
    }
    
    setChecked(!checked)
  }

  useEffect(() => {
    if ( checked !== item.active ) {
      setChecked(item.active)
    }
  }, [item.active])

  return (
    <div className="c-searchCheckbox h-checkbox">
     <label className="h-checkbox__label">
       <input className="h-checkbox__input" type="checkbox" checked={checked} onChange={onChange} />
       <div className="h-checkbox__icon" />
       <span>{label}</span>
     </label>
    </div>
  )
} 

function propsAreEqual(prev, next) {
  return prev.item.active === next.item.active
}

export default memo(CheckboxWrapper, propsAreEqual);